$(document).ready(function () {
  $('a[href="#buyBolde"], .bolde_btn-main, .bolde_header-btn').on("click", (e) => {
      e.preventDefault();

      let target = $("#buyBolde");
      if (!target.length) {
        target = $("#bottles");
      }

      if (!target.length) return;

      const offset = target.offset().top - 64;
      $("html, body").animate({ scrollTop: offset }, 400);
    }
  );

  $('a[href="#judgeme_product_reviews"]').on("click", function (e) {
    e.preventDefault();
    const target = $("#judgeme_product_reviews");
    if (!target.length) return;
    const preferredOffset = Number($(this).data("offset")) || 100;
    const offset = target.offset().top - preferredOffset;
    $("html, body").animate({ scrollTop: offset }, 400);
  });

  $(".bb-product_gallery_flex").each(function (index) {
    var $container = $(this);
    var $thumbs = $container.find(".gallery-thumbs")[0];
    var $main = $container.find(".main-gallery")[0];
    var $nextBtn = $container.find(".swiper-button-next")[0];
    var $prevBtn = $container.find(".swiper-button-prev")[0];

    var galleryThumbs = new Swiper($thumbs, {
      spaceBetween: 8,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      direction: "vertical",
      loop: true,
    });

    var mainGallery = new Swiper($main, {
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: $nextBtn,
        prevEl: $prevBtn,
      },
      thumbs: {
        swiper: galleryThumbs,
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
    });
  });

  $(".bold_classic-qty-plus").click(function () {
    $(".bold_classic-qty-min").removeClass("disable");
    var currentVal = parseFloat($(".bold_classic-qty-val").html());
    currentVal++;
    $(".bold_classic-qty-val").html(currentVal);
  });

  $(".bold_classic-qty-min").click(function () {
    var currentVal = parseFloat($(".bold_classic-qty-val").html());
    if (currentVal > 1) {
      currentVal--;
    }
    if (currentVal < 3) {
      $(".bold_classic-qty-min").addClass("disable");
    }

    $(".bold_classic-qty-val").html(currentVal);
  });

  $(".bolde_upsell-nav-next-mob").click(function () {
    $(".bolde_upsell-nav-next").trigger("click");
  });

  $(".bb_tab-popup-close").click(function () {
    $(".bb_tab-popup-outer").hide();
  });

  $(".bb_tab-expand-trigger").click(function () {
    $(".bb_tab-popup-outer").css("display", "flex");
  });

  $(".bolde_carro-faq-block").click(function () {
    $(this).toggleClass("active");
    $(this).find(".bolde_carro-faq-content").slideToggle();
  });

  $(".bolde_classic-variant-flavour-select").change(function () {
    var currentVal = $(this).val();

    //start alex new fix
    var selectedText = $(this).find("option:selected").text();
    $(".selected-flavor-text").text(selectedText);
    //end alex new fix
    var currentServings = $(".bolde_selection-serving-tab.active").attr("data");
    var fullTitle = currentVal + "-" + currentServings;
    var id = $('.bolde_product-config[data-title="' + fullTitle + '"]').attr(
      "data-id"
    );

    $(".bb-product-atc_primary-classic").attr("data-id", id);

    console.log(id, "ID IS");

    $(".bb-product_gallery_flex").addClass("hidden");
    $('.bb-product_gallery_flex[data-id="' + id + '"]').removeClass("hidden");

    var stock = $('.bolde_product-config[data-title="' + fullTitle + '"]').attr(
      "data-stock"
    );

    if (stock == "1") {
      $(".bb-product_atc").removeClass("disabled");
      $(".bb-product_atc").find(".atc_text").html("ADD TO CART");
    } else {
      $(".bb-product_atc").addClass("disabled");
      $(".bb-product_atc").find(".atc_text").html("SOLD OUT");
    }
  });

  $(".bolde_selection-serving-tab").click(function () {
    $(".bolde_selection-serving-tab").removeClass("active");
    $(this).addClass("active");

    var currentVal = $(".bolde_classic-variant-flavour-select").val();
    var currentServings = $(".bolde_selection-serving-tab.active").attr("data");
    var fullTitle = currentVal + "-" + currentServings;
    var id = $('.bolde_product-config[data-title="' + fullTitle + '"]').attr(
      "data-id"
    );
    var stock = $('.bolde_product-config[data-title="' + fullTitle + '"]').attr(
      "data-stock"
    );

    console.log(id, "ID IS");

    if (stock == "1") {
      $(".bb-product_atc").removeClass("disabled");
      $(".bb-product_atc").find(".atc_text").html("ADD TO CART");
    } else {
      $(".bb-product_atc").addClass("disabled");
      $(".bb-product_atc").find(".atc_text").html("SOLD OUT");
    }

    $(".bb-product-atc_primary-classic").attr("data-id", id);

    $(".bb-product_gallery_flex").addClass("hidden");
    $('.bb-product_gallery_flex[data-id="' + id + '"]').removeClass("hidden");
  });

  $(".bolde_upsell-nav-prev-mob").click(function () {
    $(".bolde_upsell-nav-prev").trigger("click");
  });

  $('.bb-product-color_box').click(function () {
    $(this).addClass('active');
    $('.bb-product-color_box').removeClass('active');
    $('.bb-product-atc_primary').prop('disabled', false);
    $('.bb-product-atc_primary').removeClass('disabled');
    $('.atc_text').text('ADD TO CART');
    $(this).addClass("active");
    var currentId = $(this).attr('data-id');
    $('.bb-product-atc_primary').attr('data-id', currentId);
    document.dispatchEvent(new CustomEvent('stylux:variant-changed', {
      detail: {
        variantId: currentId
      },
      bubbles: true
    }));

    var currentTitle = $(this).attr("data-title");
    var currentTag = $(this).attr("data-var-tag");
    $('.bb-product__color').html(currentTitle);
    if (currentTag && currentTag.trim() !== "") {
        $('.bb-product__tag').html(currentTag).css('display', 'inline');
    } else {
        $('.bb-product__tag').css('display', 'none');
    }

    $('.bb-price_line').addClass('hidden');
    $('.bb-price_line[data-id="' + currentId + '"]').removeClass('hidden');

    $('.bb-product_gallery_flex').addClass('hidden');
    $('.bb-product_gallery_flex[data-id="' + currentId + '"]').removeClass('hidden');

    var currentAvailable = $('.bb-price_line[data-id="' + currentId + '"]').attr('data-available');
    if (currentAvailable == "true") {
      $('.bb-product_atc').find('.atc_text').html('ADD TO CART');
    } else {
      $('.bb-product_atc').find('.atc_text').html('SOLD OUT');
    }
  });

  $('.kit-selection-options input[type="radio"]').change(function () {
    if($(this).val() == 'single') {
      //alert('hello single');
      //$('.bb-product-atc_primary').prop('disabled', true);
      //$('.bb-product-atc_primary').addClass('disabled');
      //$('.bb-product-color_box').removeClass('active');
      //$('.atc_text').text('SELECT VARIANT'); 
      $('.single-kit-section').addClass('active');
      $('.bundle-kit-section').removeClass('active');
      $('.bb-addons_container').show();
      $('.first_var_single_select').trigger('click');
      $('.first_var_single_select').addClass('active');
      $('.kit-label').removeClass('kit_active');
      $(this).parent().addClass('kit_active');
      $('.parent_vs_content_hs').hide();
      $('.show_default').removeClass('hidden');
    } else {
      //alert('hello bundle');
      //$('.bb-product-atc_primary').prop('disabled', true);
      //$('.bb-product-atc_primary').addClass('disabled');
      //$('.bb-product-color_box').removeClass('active');
      //$('.atc_text').text('SELECT VARIANT');
      $('.bundle-kit-section').addClass('active');
      $('.single-kit-section').removeClass('active');
      $('.bb-addons_container').hide();
      $('.first_var_kit_select').trigger('click');
      $('.first_var_kit_select').addClass('active');
      $('.kit-label').removeClass('kit_active');
      $(this).parent().addClass('kit_active');
      $('.parent_vs_content_hs').show();
      $('.show_default').addClass('hidden');
    }
  });

  $(".bb-addons_container.v2 .bb-addons_cell").click(function (e) {
    const isActive = $(this).hasClass("active");
    $(this).toggleClass("active");
    $(this).find(".bb-addons__toggle-checkbox").prop("checked", !isActive);
  });

  $(".bb-addon_info").click(function (e) {
    e.stopPropagation();
    var currentId = $(this).attr("data-id");
    $('.bb_addon-popup[data-id="' + currentId + '"]').css("display", "flex");
  });
  $(".bb_addon-popup").click(function () {
    $(".bb_addon-popup").hide();
  });

  $(".bb_accordion-tab").click(function () {
    $(this).toggleClass("active");
    $(this).find(".bb_accordion-content").slideToggle();
  });

  $(".bolde_faq-line").click(function () {
    $(this).toggleClass("active");
    $(this).find(".bolde_faq-content").slideToggle();
  });

  const swiper = new Swiper(".swiper.bolde-reviews_carousel", {
    loop: true,
    spaceBetween: 32,
    slidesPerView: 3, // default for desktop

    navigation: {
      nextEl: ".bolde-reviews_carousel-outer .swiper-button-next",
      prevEl: ".bolde-reviews_carousel-outer .swiper-button-prev",
    },
    pagination: {
      el: ".bolde_reviews.swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      // when window width is <= 767px (mobile)
      0: {
        slidesPerView: 1,
      },
      // tablet and up
      768: {
        slidesPerView: 2,
      },
      // desktop and up
      1024: {
        slidesPerView: 3,
      },
    },
  });

  const productUpsellsSwiper = new Swiper(".bb-addons_container.v2.swiper", {
    loop: true,
    spaceBetween: 12,
    slidesPerView: 2.3, // default for desktop

    navigation: {
      nextEl: ".bb-addons_container.v2 .bb-addons_header-btns .swiper-button-next",
      prevEl: ".bb-addons_container.v2 .bb-addons_header-btns .swiper-button-prev",
    },
    pagination: {
      el: ".bb-addons_container.v2 .bb-addons_header-btn-dots.swiper-pagination",
      clickable: true,
    },
  });

  $(".bolde_youtube-popup-close").click(function () {
    $(".bolde_youtube-popup-outer").hide();
  });

  $(".bolde_product-video-trigger").click(function () {
    $(".bolde_youtube-popup-outer").css("display", "flex");
  });

  $(".first_var_kit_select").trigger("click");
  $(".first_var_kit_select").addClass("active");
  $(".bb-addons_container.hide_default").hide();
  // new js. 
  //$('.bb-addons_container.hide_default').hide();
  
  $(".bolde_header-nav-cell").click(function () {
    $(".bolde_header-nav-cell").removeClass("active");
    $(this).addClass("active");
    var data = $(this).attr("data-id");
    $(".bb-section-outer.boldeBottle_grid").hide();
    $(".bb-section-outer.boldeBottle_coll").hide();
    if (data == "all") {
      $(".bb-section-outer.boldeBottle_grid").show();
      $(".bb-section-outer.boldeBottle_coll").show();
    } else {
      $('.bb-section-outer.boldeBottle_grid[id="' + data + '"]').show();
      $('.bb-section-outer.boldeBottle_coll[id="' + data + '"]').show();
    }
  });
});
